<div *ngIf='sessionData && dataReady' class='ViewMessage container pt-3'>
  <div class='d-flex flex-row justify-content-between'>
    <div class='Breadcrumbs'>
      <div class='Breadcrumbs-items'>
        <a [routerLink]='getBackRoute()'
        >
          <mat-icon class='Breadcrumbs-icon back'
          >keyboard_backspace
          </mat-icon
          >
        </a
        >
        <a class='Breadcrumbs-item'>{{ getResponseStatus() }}</a>
      </div>
    </div>
    <div *ngIf="sessionData && sessionData.user_type === 'vsm'">
      <div
        *ngIf='lockedBannerState === locketBannerStates.SELF; else other'
        [class.alert-danger]='vsmRemainingTime < 10 * 1000'
        [class.alert-info]='vsmRemainingTime >= 10 * 1000'
        class='alert'>
        <p class='mb-0'>
          This message have been locked for you only. You have
          <b>{{ vsmRemainingMinutes }}:{{ vsmRemainingSeconds }}</b> to work on
          it!
        </p>
      </div>
      <ng-template #other>
        <div class='alert alert-danger'>
          <p class='mb-0'>
            This message is locked by <b>{{ lockedByUser }}</b
          >!
          </p>
        </div>
      </ng-template>
    </div>
    <ng-container
      *ngIf="
        contactGroup === 'temp' && isUnmatchedMessage();
        else normalResponse
      ">
      <app-button
        *ngIf="sessionData.user_type !== 'vsm'; else vsmButton"
        [Click]='responseButtonProperties.onClick'
        [color]='responseButtonProperties.color'
        [size]='responseButtonProperties.size'
        [text]='responseButtonProperties.text'></app-button>
      <ng-template #vsmButton>
        <app-button-select
          *ngIf='
            vsmResponseButtonProperties &&
            vsmResponseButtonProperties.buttonProperties
          '
          [buttonProperties]='vsmResponseButtonProperties.buttonProperties'
          [items]='vsmResponseButtonProperties.items'></app-button-select>
      </ng-template>
    </ng-container>
    <ng-template #normalResponse>
      <app-button-select
        *ngIf="
          sessionData.user_type !== 'manager' &&
          sessionData.user_type !== 'partner' &&
          responseButtonSelect &&
          responseButtonSelect.buttonProperties &&
          (sessionData.user_type !== 'vsm' ||
            lockedBannerState === locketBannerStates.SELF)
        "
        [buttonProperties]='responseButtonSelect.buttonProperties'
        [items]='responseButtonSelect.items'></app-button-select>
    </ng-template>
  </div>
  <ng-container *ngIf='emptyState; else data'>
    <p class='ViewMessage__no-data text-center'>No data to display</p>
  </ng-container>
  <ng-template #data>
    <div class='ViewMessage__container mt-5 p-5'>
      <div class='d-flex flex-row align-items-center justify-content-between'>
        <div *ngIf='hasResponseStatus()' class='ViewMessage__container__status'>
          <p class='text-left text-capitalize mb-0'>
            <b>Current Contact Status: </b><span>{{ getResponseStatus(true) }}</span>
          </p>
          <p *ngIf='!isUnmatchedMessage() && shouldShowNextServiceDate()' class='text-left ms-3 mb-0'>
            <b>Next Email Date: </b
            ><span>{{
              getNextEmailDate()
                | timezone: 'MM/DD/YYYY' : sessionData.time_zone
            }}</span>
          </p>
          <p *ngIf='getMessageCampaing()' class='ms-3'>
            <b>Campaign: </b><span>{{ getMessageCampaing() }}</span>
          </p>
        </div>
        <div class='ViewMessage__container__plain'>
          <mat-checkbox
            (change)='viewAsPlain = $event.checked'
            [value]='viewAsPlain'
          >View as plain
          </mat-checkbox
          >
        </div>
        <div class='ViewMessage__container__nav'>
          <app-button
            *ngIf='preMessageId'
            [Click]="onNavigationButtonClick.bind(this, 'prev')"
            [color]="'blue'"
            [text]="'Previous'"></app-button>
          <app-button
            *ngIf='nextMessageId'
            [Click]="onNavigationButtonClick.bind(this, 'next')"
            [color]="'blue'"
            [text]="'Next'"></app-button>
        </div>
      </div>
      <div class='ViewMessage__container__message mt-5'>
        <ng-container *ngIf='messages && messages.length > 0'>
          <app-message-viewer
            *ngFor='let message of messages; let i = index'
            [asPlainText]='viewAsPlain'
            [message]='message'
            [sessionData]='sessionData'
            [showReleaseNote]='i === 0'></app-message-viewer>
        </ng-container>
      </div>
    </div>
  </ng-template>
</div>
